import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface ClienteVinculo {
  id: string;
  cliente_id: string;
  org_id: string;
  rol: string;
  cliente_nombre: string;
  org_nombre: string;
}

/**
 * Hook que devuelve los vínculos cliente↔usuario del usuario autenticado.
 * Usado por el Portal B2B para saber qué cliente representa el usuario.
 */
export function useClienteUser() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["cliente-users", user?.id],
    enabled: !!user?.id,
    queryFn: async (): Promise<ClienteVinculo[]> => {
      const { data, error } = await supabase
        .from("cliente_users")
        .select(
          "id, cliente_id, org_id, rol, clientes(nombre), organizaciones(nombre)"
        )
        .eq("user_id", user!.id);

      if (error) throw error;

      return (data ?? []).map((row: any) => ({
        id: row.id,
        cliente_id: row.cliente_id,
        org_id: row.org_id,
        rol: row.rol,
        cliente_nombre: row.clientes?.nombre ?? "Cliente",
        org_nombre: row.organizaciones?.nombre ?? "Agencia",
      }));
    },
  });
}
